import { tv } from 'tailwind-variants';
import EmptyIcon from '@/shared/assets/empty-icon.svg?react';
import { cn } from '../utils';

interface Props {
  title: string;
  description: string;
  className?: string;
}

const emptyStateStyles = tv({
  slots: {
    container: 'flex flex-col items-center justify-center gap-[3.2rem]',
    imageContainer:
      'w-[6.4rem] h-[6.4rem] flex items-center justify-center text-foreground',
    image: 'w-[5rem] h-[5rem]',
    content: 'text-center',
    title: 'headline4 text-foreground mb-[0.8rem]',
    description: 'p4 text-muted-foreground',
  },
});

export function ItemsListEmptyState({ title, description, className }: Props) {
  const c = emptyStateStyles();
  return (
    <div className={cn(c.container(), className)}>
      <div className={c.imageContainer()}>
        <EmptyIcon className={c.image()} />
      </div>
      <div className={c.content()}>
        <div className={c.title()}>{title}</div>
        <div className={c.description()}>{description}</div>
      </div>
    </div>
  );
}
